import styled from "@emotion/styled";
import ShieldIcon from "img/shield.svg?react";
import WalletIcon from "img/wallet.svg?react";
import FlaskIcon from "img/flask.svg?react";
import ClipboardIcon from "img/clipboard.svg?react";
import StreamerImage5 from "../../../img/home/streamer-5.svg?react";
import hackerImgSrc from "../../../img/home/hacker.png";
import { MOBILE_WIDTH, useIsMobile } from "hooks/useDeviceType";
import { css } from "@emotion/react";
import { Title as TitleOriginal } from "./element/Title";
import { Text } from "components/general/Text";
import { Badge as BadgeOriginal } from "./element/Badge";
import { Spacer } from "components/general/Spacer/Spacer";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export const FeatureSecurity = () => {
  const isMobile = useIsMobile();

  return (
    <Container>
      <img
        src={hackerImgSrc}
        alt="Hacker with lightning bolts around"
        css={css`
          width: 444px;
          z-index: 1;
          @media (max-width: ${MOBILE_WIDTH}px) {
            width: 203px;
            height: 163px;
          }
        `}
      />
      <Badge icon={ShieldIcon} text="Security" />
      <MainContentContainer>
        <TextContainer>
          <Title>Keeping your funds safe in an uncertain world</Title>
          <Text
            textStyle="Paragraph"
            size="Mega"
            textCss={css`
              max-width: 1000px;
            `}
            shouldScale={true}
          >
            Security is at the core of our business and technology practices.
          </Text>
        </TextContainer>
        <Feature />
      </MainContentContainer>

      <div style={{ position: "absolute", top: isMobile ? -304 : -368, left: 0, zIndex: 0 }}>
        <StreamerImage5 {...(isMobile ? { width: 100 } : {})} />
      </div>
    </Container>
  );
};

// Sub-components

const Container = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
`;

const MainContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
  width: 100%;

  @media (max-width: ${MOBILE_WIDTH}px) {
    gap: 40px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
`;

const Title = styled(TitleOriginal)`
  margin-bottom: 24px;
  max-width: 800px;
`;

const Badge = styled(BadgeOriginal)`
  margin-top: 38px;
  margin-bottom: 28px;
`;

const Feature = () => {
  const ref = useRef(null);
  const isVisible = useInView(ref);
  return (
    <FeatureContainer ref={ref}>
      {isVisible && (
        <>
          <div>
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.3 }}
            >
              <WalletIcon width={48} height={48} />
            </motion.div>
            <Spacer height={16} />
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.4 }}
            >
              <Text textStyle="Paragraph" size="XXL" shouldScale={true}>
                We never control or lock users’ funds
              </Text>
            </motion.div>
          </div>
          <div>
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.5 }}
            >
              <FlaskIcon width={48} height={48} />
            </motion.div>
            <Spacer height={16} />
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.6 }}
            >
              <Text textStyle="Paragraph" size="XXL" shouldScale={true}>
                We utilize the most tried and tested technologies and partners
              </Text>
            </motion.div>
          </div>
          <div>
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.7 }}
            >
              <ClipboardIcon width={44} height={44} />
            </motion.div>
            <Spacer height={16} />
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.8 }}
            >
              <Text textStyle="Paragraph" size="XXL" shouldScale={true}>
                We hire the best smart contract auditors and cybersecurity testers
              </Text>
            </motion.div>
          </div>
        </>
      )}
    </FeatureContainer>
  );
};

const FeatureContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 70%;
  max-width: 768px;

  @media (max-width: ${MOBILE_WIDTH}px) {
    gap: 32px;
    grid-template-columns: auto;
    grid-template-rows: repeat(3, 1fr);
    width: 50%;
  }
`;
